import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function ShapeDividerRender({ node }) {
  const content = node.content || {};
  
  const type = content.type || 'waves'; // waves, tilt, arrow
  const color = content.color || 'var(--tef-primary, #00A9E0)';
  const height = parseInt(content.height, 10) || 100;
  const position = content.position || 'bottom'; // top, bottom
  const flip = content.flip === 'true';
  const invert = content.invert === 'true';

  let svgPath = '';
  if (type === 'waves') {
    svgPath = 'M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z';
  } else if (type === 'tilt') {
    svgPath = 'M1200 120L0 16.48V0h1200v120z';
  } else if (type === 'arrow') {
    svgPath = 'M1200 0L0 0 598.97 114.72 1200 0z';
  }

  return (
    <div style={{
      position: 'absolute',
      left: 0,
      width: '100%',
      overflow: 'hidden',
      lineHeight: 0,
      zIndex: 0, // In background
      [position]: 0,
      transform: `rotate(${position === 'top' ? 180 : 0}deg) ${flip ? 'scaleX(-1)' : ''} ${invert ? 'scaleY(-1)' : ''}`
    }}>
      <svg 
        viewBox="0 0 1200 120" 
        preserveAspectRatio="none" 
        style={{ width: '100%', height: `${height}px`, display: 'block' }}
      >
        <path d={svgPath} fill={color}></path>
      </svg>
    </div>
  );
}

registry.register('ShapeDivider', {
  label: 'SVG Formen Trenner',
  icon: '🌊', 
  category: 'layout', // Shape Divider ordne ich gerne unter Layout ein
  component: ShapeDividerRender,
  
  defaultProps: {
    content: {
      type: 'waves',
      color: '#00A9E0',
      height: '80',
      position: 'bottom',
      flip: 'false',
      invert: 'false'
    },
    style: {
      desktop: {
        width: '100%',
        position: 'relative' // Parent needs relative for absolute shape to attach to
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Trenner Form',
          fields: [
            { name: 'content.type', label: 'Form', type: 'select', options: ['waves', 'tilt', 'arrow'] },
            { name: 'content.color', label: 'Füllfarbe', type: 'color' },
            { name: 'content.height', label: 'Höhe in Pixel (z.B. 80)', type: 'text' }
          ]
        },
        {
          title: 'Positionierung',
          fields: [
            { name: 'content.position', label: 'Anbringen oben oder unten?', type: 'select', options: ['top', 'bottom'] },
            { name: 'content.flip', label: 'Horizontal spiegeln?', type: 'select', options: ['false', 'true'] },
            { name: 'content.invert', label: 'Vertikal invertieren?', type: 'select', options: ['false', 'true'] }
          ]
        }
      ]
    }
  ]
});
